import { useEffect, useState } from "react";
import ProductService from "../service/ProductService";
import useApiStatus from "./useApiStatus";

const useGetCommentsOfStore = ({ username, onError }) => {
  const { isLoading, setIsLoading, hasError, setHasError } = useApiStatus();
  const [commentsOfStore, setCommentsOfStore] = useState([]);

  const productService = new ProductService();

  const loadComments = async (username) => {
    try {
      setIsLoading(true);
      const res = await productService.getCommentsOfStore(username);
      if (res.messageCode !== 200001) {
        setHasError(true);
        onError(res.messageCode);
      } else {
        setHasError(false);
        setCommentsOfStore(res.result);
      }
    } catch (e) {
      setHasError(true);
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (username) loadComments(username); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);

  return {
    isLoading,
    commentsOfStore,
    hasError,
  };
};

export default useGetCommentsOfStore;
